import * as blockEngine from '@smartfire/js-block-engine';
export default blockEngine;